// src/components/Comptable/documents/DocumentSectionLayout.jsx
import { Box, Typography, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const DocumentSectionLayout = ({ title, onBack, children, right }) => {
    return (
        <Box>
            {/* Header */}
            <Box
                sx={{
                    mb: 4,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{ fontWeight: 'bold', color: 'text.primary', fontSize: '1.6rem' }}
                >
                    {title}
                </Typography>

                <Box sx={{ display: 'flex', gap: 1 }}>
                    {right}
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={onBack}
                        startIcon={<ArrowBackIcon />}
                    >
                        Retour
                    </Button>
                </Box>
            </Box>

            {/* Contenu spécifique à la sous-page */}
            <Box>{children}</Box>
        </Box>
    );
};

export default DocumentSectionLayout;
